import type { Variants } from 'framer-motion';

import { ToastAlertPosition } from '../ToastContext';

export const PositionAnimationVariants: Record<ToastAlertPosition, Variants> = {
  [ToastAlertPosition.topRight]: {
    initial: { opacity: 0, x: 100, height: 0, marginBottom: 0 },
    animate: { opacity: 1, x: 0, height: 'auto', marginBottom: 16 },
    exit: { opacity: 0, x: 100, height: 0, marginBottom: 0 },
  },
  [ToastAlertPosition.topLeft]: {
    initial: { opacity: 0, x: -100, height: 0, marginBottom: 0 },
    animate: { opacity: 1, x: 0, height: 'auto', marginBottom: 16 },
    exit: { opacity: 0, x: -100, height: 0, marginBottom: 0 },
  },
  [ToastAlertPosition.bottomRight]: {
    initial: { opacity: 0, x: 100, height: 0, marginBottom: 0 },
    animate: { opacity: 1, x: 0, height: 'auto', marginBottom: 16 },
    exit: { opacity: 0, x: 100, height: 0, marginBottom: 0 },
  },
  [ToastAlertPosition.bottomLeft]: {
    initial: { opacity: 0, x: -100, height: 0, marginBottom: 0 },
    animate: { opacity: 1, x: 0, height: 'auto', marginBottom: 16 },
    exit: { opacity: 0, x: -100, height: 0, marginBottom: 0 },
  },
};
